var _excluded = ["id", "textSize", "status", "surfaceColor", "indeterminate", "label", "disabled", "hasIdentation", "autotagging-flora", "data-autotagging-flora-section", "data-flora-text", "aria-label", "aria-disabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef } from '@grupoboticario/flora-react-system';
import { useFloraCheckbox } from './useFloraCheckbox';
import { StyledCheckboxWrapper, StyledCheckboxInput, StyledCheckboxLabel, StyledCheckboxSpan } from './styles';
/**
 * @component
 * @name FloraCheckbox
 * @description Também conhecido como caixa de seleção, é empregado quando existe uma lista de opções e o usuário pode escolher várias alternativas, incluindo todas ou nenhuma. Cada FloraCheckbox é independente dos demais na lista, por isso selecionar uma caixa de seleção não afeta o estado dos outros itens.
 * @tutorial https://florabook.gb.tech/v2/index.html?path=/docs/core-components-floracheckbox
 */

export var FloraCheckbox = forwardRef((_ref, forwardedRef) => {
  var {
    id,
    textSize = 'medium',
    status = 'neutral',
    surfaceColor = 'light',
    indeterminate,
    label,
    disabled,
    hasIdentation = false,
    'autotagging-flora': autotaggingFlora = 'off',
    'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
    'data-flora-text': dataFloraText,
    'aria-label': ariaLabel,
    'aria-disabled': ariaDisabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var {
    ref
  } = useFloraCheckbox({
    forwardedRef,
    indeterminate
  });
  return /*#__PURE__*/React.createElement(StyledCheckboxWrapper, null, /*#__PURE__*/React.createElement(StyledCheckboxInput, _extends({}, props, {
    id: id,
    ref: ref,
    as: "input",
    "data-flora": "checkbox",
    "autotagging-flora": autotaggingFlora,
    "data-flora-text": dataFloraText || ariaLabel || label,
    "data-autotagging-flora-section": dataAutotaggingFloraSection,
    type: "checkbox",
    surfaceColor: surfaceColor,
    textSize: textSize,
    status: status,
    disabled: disabled,
    "aria-label": ariaLabel,
    "aria-invalid": status === 'error',
    "aria-disabled": ariaDisabled,
    hasIdentation: hasIdentation
  })), /*#__PURE__*/React.createElement(StyledCheckboxLabel, {
    htmlFor: id,
    disabled: Boolean(disabled || ariaDisabled)
  }, /*#__PURE__*/React.createElement(StyledCheckboxSpan, null), label));
});
//# sourceMappingURL=FloraCheckbox.js.map